import { render, staticRenderFns } from "./InvestorBlock.vue?vue&type=template&id=adaeae28"
import script from "./InvestorBlock.vue?vue&type=script&lang=js"
export * from "./InvestorBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports